<template>
    <div class="cointainer">
        <div class="top">
            <div class="leftImg">

            </div>
            <div class="right">
                <div class="top">
                    <div class="teacher">{{this.$getUserInfo().name|| '老师'}}，上午好</div>
                    <div class="speak">闻见广则聪明辟，胜友之而学易成。</div>
                    <div class="prePareClass">
                        <div class="textClassName">上次备课</div>
                        <div class="className">
                            <span class="name">{{allMess&&allMess.disPlayName}}</span>
                            <span class="goOn" @click="goOnFun">继续备课</span>
                            <img class="img" src="../../assets/teacherRoad/04.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="bot">
                    <div class="left">
                        <img class="img" src="../../assets/teacherRoad/02.png" alt="" />
                        <div class="num">{{replyMess&&replyMess.expertCount}}</div>
                        <div class="text">待解决问题</div>
                    </div>
                    <div class="right">
                        <img class="img" src="../../assets/teacherRoad/03.png" alt="" />
                        <div class="num">{{replyMess&&replyMess.teacherCount}}</div>
                        <div class="text">专家回复</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="videoBot">
            <div class="left">
                <div class="title">
                    <span class="tit">蜗牛视频</span>
                    <span class="more" @click="lookMoreVideo">查看更多</span>
                </div>
                <ul class="content">
                    <li v-for="(item,index) in videoList" :key="index" @click="lookVideoDetai(item)">
                        <div class="readText">{{item.title}}</div>
                        <div class="look" @click="lookSnailVideo">查看</div>
                    </li>

                </ul>
            </div>
            <div class="right1">
                <div class="title">
                    <span class="tit">蜗牛文章</span>
                    <span class="more" @click="lookSnailBook">查看更多</span>
                </div>
                <ul class="contentUl">
                    <li class="ulLi" v-for="(item,index) in bookList" :key="index">
                        <img class="tb" src="../../assets/teacherRoad/14.png" alt="" />
                        <span class="kb">课标</span>
                        <span class="text">{{item.title}}</span>
                        <span class="author">{{item.authorName}}</span>
                        <span class="look" @click="lookSnailBook">查看</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data(){
        return{
            videoList: [], //蜗牛视频
            bookList: [], // 蜗牛文章
            replyMess: {}, //专家回复
            allMess: {}
        }
    },
    mounted(){
        this.getAll()
        this.getVideoList()
        this.getBookList()
        this.getTeacherAskAndExpertReplyCount()
    },
    methods:{
        //ebook/teacher/homePage/getAll
        getAll(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/homePage/getAll',
                body: {}
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.allMess = res.resultData.lessonPrepare
                }
            })
        },
        //视频列表/ebook/teacher/live/getMediaCategoryList
        getVideoList(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/live/getMediaCategoryList',
                body: {}
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.videoList = res.resultData.slice(0,4)
                }
            })
        },
        lookMoreVideo(){ //查看更多蜗牛视频
            this.$router.push({name: 'snailVideoList'})
        },
        lookVideoDetai(item){ //蜗牛视频查看详情

        },
        //蜗牛文章 ebook/teacher/article/getArticleList
        getBookList(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/article/getArticleList',
                body: {
                    pageSize: 4,
                    pageNum:1
                }
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    if(res.resultData&&res.resultData.list){
                        this.bookList = res.resultData.list
                    }
                }
            })
        },
        //获取待解决问题 ebook/teacher/ask/getTeacherAskAndExpertReplyCount
        getTeacherAskAndExpertReplyCount(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/ask/getTeacherAskAndExpertReplyCount',
                body: {
                    userId: this.$getUserInfo().id
                }
            }).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.replyMess = res.resultData
                }
            })
        },
        goOnFun(){
            this.$router.push({name: 'Books'})
        },
        lookSnailVideo(){
            this.$router.push({name: 'snailVideoList'})
        },
        lookSnailBook(){
            this.$router.push({name: 'snailBookList'})
        }
    }

}
</script>

<style scoped lang="less">
    ul,li{
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .cointainer{
        width: 1240px;
        margin: 0 auto;
        margin-top: 30px;
        .top{
            height: 420px;
            width: 100%;
            display: flex;
            .leftImg{
                display: block;
                width: 740px;
                height: 100%;
                background:url('../../assets/homepage/01.png') no-repeat center center;
                background-size: 100% 100%;
            }
            .right{
                margin-left: 20px;
                width: 480px;
                height: 100%;
                .top{
                    width: 100%;
                    height: 200px;
                    padding: 30px;
                    background: #fff;
                    display: block;
                    .teacher{
                        color: #000;
                        font-size: 24px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }
                    .speak{
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                        line-height: 20px;
                        margin-top: 10px;
                    }
                    .prePareClass{
                        display: flex;
                        margin-top: 10px;
                        .textClassName{
                            width: 60px;
                            height: 40px;
                            line-height: 80px;
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #7F7F7F;

                        }
                        .className{
                            cursor: pointer;
                            display: inline-block;
                            margin-left: 20px;
                            margin-top: 20px;
                            width: 320px;
                            height: 40px;
                            line-height: 40px;
                            background: url('../../assets/teacherRoad/01.png') no-repeat;
                            background-size: 100% 100%;
                            position: relative;
                            .name{
                                font-size: 16px;
                                color: #fff;
                                position: absolute;
                                left: 30px;
                            }
                            .goOn{
                                font-size: 12px;
                                color: #fff;
                                opacity: .8;
                                position: absolute;
                                right: 40px;
                            }
                            .img{
                                width: 12px;
                                height: 12px;
                                position: absolute;
                                right: 20px;
                                top: 14px;
                            }
                        }
                    }
                }
                .bot{
                    margin-top: 20px;
                    height: 200px;
                    background: #fff;
                    display: flex;
                    padding: 30px;
                    .left,.right{
                        width: 50%;
                        height: 100%;
                        text-align: center;
                        .img{
                            width: 50px;
                            height: 44px;
                            margin-top: 5px;
                        }
                        .num{
                            font-size: 24px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: @primary-color;
                            line-height: 30px;
                            margin-top: 8px;
                        }
                        .text{
                            font-size: 16px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000000;
                            line-height: 20px;
                            margin-top: 15px;
                        }
                    }
                    .left{
                        border-right: 1px solid #E6DDD0;
                    }
                    .right{
                        margin-left: 0px;
                    }
                }
            }
        }
        .videoBot{
            margin-top: 10px;
            display: flex;
            .left,.right1{
                width: 610px;
                height: 200px;
                background: #fff;
                padding: 20px 30px;
                .title{
                    height: 50px;
                    position: relative;
                    .tit{
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        font-size: 18px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #000000;
                        line-height: 28px;
                    }
                    .more{
                        position: absolute;
                        right: 0px;
                        top: 5px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 20px;
                        cursor: pointer;
                    }
                }
            }
            .left{
                .content{
                    font-family: PingFangSC-Regular, PingFang SC;
                    display: flex;
                    flex-wrap: nowrap;
                    li{
                        margin-right: 25px;
                        width: 120px;
                        height: 92px;
                        background: #f6f6f6;
                        text-align: center;
                        padding: 10px 0px;
                        cursor: pointer;
                        .readText{
                            height: 30px;
                            line-height: 30px;
                            font-weight: 400;
                            color: #000000;
                            line-height: 26px;

                        }
                        .look{
                            cursor: pointer;
                            width: 60px;
                            height: 20px;
                            border-radius: 2px;
                            border: 1px solid @primary-color;
                            margin: 0 auto;
                            margin-top: 10px;
                            color: @primary-color;
                            font-size: 12px;
                        }
                        &:last-child{
                            margin-right: 0px;
                        }
                    }
                }
            }
            .right1{
                margin-left: 20px;
                width: 610px;
                height: 200px;
                background: #fff;
                .contentUl{
                    .ulLi{
                        position: relative;
                        display: block;
                        .tb{
                            left: 0px;
                            top: 5px;
                            width: 10px;
                            height: 10px;
                        }
                        .kb{
                            position: absolute;
                            left: 20px;
                            top: 2px;
                            color: #999;
                            font-size: 12px;
                        }
                        .text{
                            position: absolute;
                            display: inline-block;
                            left: 70px;
                            font-size: 14px;
                            color: #000;
                            width: 300px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .author{
                            position: absolute;
                            right: 70px;
                            top: 2px;
                            font-size: 12px;
                            color: #999999;
                        }
                        .look{
                            position: absolute;
                            right: 0px;
                            display: inline-block;
                            width: 60px;
                            height: 18px;
                            line-height:18px;
                            background: #FFFFFF;
                            border-radius: 2px;
                            border: 1px solid @primary-color;
                            text-align: center;
                            color: @primary-color;
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>
